import { render } from "./LinesSidebar.vue?vue&type=template&id=0f2c8f42&ts=true"
import script from "./LinesSidebar.vue?vue&type=script&lang=ts"
export * from "./LinesSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__